import React from 'react';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { ShippingDisplay } from '../../../type/common.type';

interface ShippingFeeRowProps extends ShippingDisplay {}

export const ShippingFeeRow: React.FC<ShippingFeeRowProps> = ({
  mode,
  text,
  left_name,
  left_value,
  right_name,
  right_value,
}) => {
  if (mode === 'hidden') return null;
  if (mode === 'text') return <Container>{text}</Container>;

  return (
    <Container>
      <ShippingAmount>
        <Name>{left_name}</Name>
        <Dot />
        <Value>{left_value}</Value>
        <Divider />
        <Name>{right_name}</Name>
        <Dot />
        <Value>{right_value}</Value>
      </ShippingAmount>
    </Container>
  );
};

const Container = styled.div`
  margin: 6px 0 0 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  height: 17px;
  font-size: 14px;
  font-weight: 400;
  color: ${vars.v3Color.gray500};
`;

const Dot = styled.span`
  margin: 0 3px;
  position: relative;
  top: -4px;
  display: inline-block;
  width: 2px;
  height: 2px;
  background-color: ${vars.v3Color.gray200};
`;

const Divider = styled.span`
  position: relative;
  top: 1px;
  margin: 0 5px;
  display: inline-block;
  width: 1px;
  height: 12px;
  background-color: ${vars.v3Color.gray200};
`;

const ShippingAmount = styled.span`
  position: relative;
  color: ${vars.v3Color.gray700};
`;

const Name = styled.span`
  font-weight: 500;
`;

const Value = styled.span`
  font-weight: 400;
`;
